export default __webpack_public_path__ + "static/img/issue_resoluation.77dce08.svg";